import { Box, Checkbox, Divider, FormControlLabel, Grid, Theme, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from './index';
import { KeyValue } from './personalDetails';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useEffect, useState } from 'react';
import { LocationType, mdmsLocationList } from '../../redux-store/types/mdms';
import { getLocationList } from '../../redux-store/actions';
import { PHYSICAL_DIGITAL_FLOW, SUBROLE } from '../../utils/constant';

export default function DistributorDetails({
  application,
  isDiyInvestorOnboarding,
  hideBseESignStatus = false
}: {
  application: ApplicationProps;
  isDiyInvestorOnboarding?: boolean;
  hideBseESignStatus?: boolean;
}): JSX.Element {
  const { isBSEEnabled, isEsignEnabled } = application || {};
  const { auth } = useSelector((store: RootStateType) => store);
  const isSupportRM = isDiyInvestorOnboarding ? false : auth.id === application?.supportRm?.userId;
  const LoginRMorSupport = isSupportRM ? application?.supportRm : application?.rm;
  const [locationMaster, setLocationMaster] = useState<mdmsLocationList[]>([]);
  const dispatch = useDispatch();
  const { subRole = '' } = useSelector((store: RootStateType) => store.auth);
  const { userRole = '' } = application?.rm || {};

  const isSubBrk = [SUBROLE.SUB_BRK].includes(`${subRole ?? ''}`.toUpperCase() as SUBROLE);
  
  useEffect(() => {
    (async function () {
      try {
        const locationmaster = (await dispatch(getLocationList())) as unknown as LocationType;
        setLocationMaster(locationmaster.rmLocationList);
      } catch (e) {
        console.log((e as Error).message);
      }
    })();
  }, []);
  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}>
        <Box>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
               {(isSubBrk) ?"Sub Broker/RM Detials":"RM Details"}
              </Typography>
            </Grid>

            {/* <Gridstyles> */}
            <Grid
              item
              container
              // pt={1}
              // pb={5}
              rowSpacing={3}
              columnSpacing={5.5}
              direction="row"
            // justifyContent="space-between"
            // alignItems="flex-start"
            >
              <KeyValue
                title={isSupportRM ? "Service RM's Name" : "RM's Name"}
                description={LoginRMorSupport?.user?.firstName}
              />
              <KeyValue
                title={isSupportRM ? "Service RM's Email Address" : "RM's Email Address"}
                description={LoginRMorSupport?.user?.email}
              />
              <KeyValue
                title={isSupportRM ? "Service RM's Mobile Number" : "RM's Mobile Number"}
                description={LoginRMorSupport?.user?.phone ?
                  (LoginRMorSupport?.user?.countryCode
                    ? LoginRMorSupport?.user?.countryCode + '-' + LoginRMorSupport?.user?.phone
                    : LoginRMorSupport?.user?.phone) : '-'
                }
              />
              {/* <KeyValue
                title={'Location'}
                // description={
                //   locationMaster.find((loc) => loc.key === LoginRMorSupport?.location)?.value
                // }
                description={LoginRMorSupport?.branchName}
              /> */}


              {isSupportRM && (
                <>
                  <KeyValue title={"RM's Name"} description={application?.rm?.user?.firstName} />
                  <KeyValue
                    title={"RM's Email Address"}
                    description={application?.rm?.user?.email}
                  />
                  <KeyValue
                    title={"RM's Mobile Number"}
                    description={
                      application?.rm?.user?.countryCode
                        ? application?.rm?.user?.countryCode + '-' + application?.rm?.user?.phone
                        : application?.rm?.user?.phone
                    }
                  />
                  <KeyValue
                    title={'Location'}
                    description={
                      locationMaster.find((loc) => loc.key === application?.rm?.location)?.value
                    }
                  />
                </>
              )}
              {/* Tagged RM Info Start */}
              {application?.taggedRm &&
                <>
                  <Grid item xs={12}>
                    <Divider sx={{ color: 'red', mt: 2 }} />
                  </Grid>
                  <Grid item xs={12} mb={-1}>
                    <Typography
                      sx={(theme: Theme) => ({
                        fontSize: 18,
                        fontWeight: 700,
                        color: theme.palette.primary[900],
                      })}
                    >
                      Tagged RM Details
                    </Typography>
                  </Grid>
                  <KeyValue
                    title={"Tagged RM's Name"}
                    description={application?.taggedRm?.user?.firstName}
                  />
                  <KeyValue
                    title={"Tagged RM's Email Address"}
                    description={application?.taggedRm?.user?.email}
                  />
                  <KeyValue
                    title={"Tagged RM's Mobile Number"}
                    description=
                    {application?.taggedRm?.user?.phone ?
                      (application?.taggedRm?.user?.countryCode
                        ? application?.taggedRm?.user?.countryCode + '-' + application?.taggedRm?.user?.phone
                        : application?.taggedRm?.user?.phone) : '-'
                    }
                  />
                  {/* <KeyValue
                    title={'Location'}
                    description={
                      locationMaster.find((loc) => loc.key === application?.taggedRm?.location)?.value
                    }
                  /> */}
                  <KeyValue
                    title={" Tagged RM's Segment"} //taking from rm level
                    description={application?.taggedRm?.segment}
                  />
                  <KeyValue
                    title={"Sub Broker Code"}
                    description={application?.subBrokerCode}
                  />
                  {application?.subBrokerCode && (
                    <KeyValue
                      title={"Sub Segment"} //taking from rm level
                      description={application?.taggedRm?.subSegment||""}
                    />
                  )}
                </>
              }
              {/* Tagged RM Info End */}

              {(!hideBseESignStatus && PHYSICAL_DIGITAL_FLOW) && (
                <>
                  <Grid item xs={12}>
                    <Divider sx={{ color: 'red', mt: 2 }} />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant='h2' mt={2}>BSE Status</Typography>
                    <Typography variant='body_500' color='text.secondary' mt={1}>{application?.isBSEEnabled ? 'MF Enabled' : 'MF Disabled'}</Typography>
                  </Grid>

                  {/*     <Grid item container mt={3}>
                    <Grid item xs={12} >
                      <FormControlLabel sx={{ "&.MuiFormControlLabel-root": { cursor: "not-allowed" } }} checked={isBSEEnabled} control={<Checkbox />} disabled label={<Typography variant="body_500" color='text.secondary'>Sent to BSE</Typography>} />

                    </Grid>
                    <Grid item xs={12} >
                      <FormControlLabel sx={{ "&.MuiFormControlLabel-root": { cursor: "not-allowed" } }} control={<Checkbox />} disabled checked={isEsignEnabled} label={<Typography variant="body_500" color='text.secondary'>Sent To E-Sign</Typography>} />
                    </Grid> 
                </Grid>*/}
                </>
              )}
            </Grid>
            {/* </Gridstyles> */}
          </Grid>
        </Box>
      </Box >
    </>
  );
}
